// The UI uses MB; limits are binary MiB (50 * 1024 * 1024 bytes).
export const MAX_FILE_BYTES = 50 * 1024 * 1024;
export const MAX_CONTENT_BYTES = 50 * 1024 * 1024;
export const INLINE_CONTENT_BYTES = 250000;
export const CONTENT_PART_BYTES = 1000000;
export const MAX_PARTS = Math.ceil(MAX_CONTENT_BYTES / CONTENT_PART_BYTES);
export const MAX_ORIGINAL_ENCODED_BYTES = Math.ceil(MAX_FILE_BYTES / 3) * 4;
export const CONTENT_REF_PREFIX = '\u001edocworks-content:';
export function contentRef(id) { return CONTENT_REF_PREFIX + id; }
export function refId(value) { return typeof value === 'string' && value.startsWith(CONTENT_REF_PREFIX) ? value.slice(CONTENT_REF_PREFIX.length) : null; }
export function textBytes(value) { return new TextEncoder().encode(value).length; }
